var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"employer-visa-cases-template"},[_c('EmployeeCard'),_c('Table')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }